import type { PlayersApi } from "@/v2/api/metadata/players";
import { createFeedConfigDialogApi } from "@/v2/kits/feed-config";
import { playerId } from "../../shared";

export function createPlayerFeedConfigApi(players: PlayersApi) {
  return createFeedConfigDialogApi(({ values }) => playerId(values), {
    getFeedTypeMappings: players.getFeedTypeMappings.bind(players),
    getFeedInstanceMappings: players.getFeedInstanceMappings.bind(players),
    updateEntity: async (entityId, payload) => {
      await players.update(entityId, payload);
    },
  });
}
